import Grid from "@mui/material/Grid";

const WeDo = () => {
  return (
    <div className="app-wedo-container">
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        className="app-wedo__gridContainer"
      >
        <Grid item xs={12} md={3} className="app-wedo__grid">
          <h2 className="wedo-headText">OUR MOTTO</h2>
        </Grid>
        <Grid item xs={12} md={9} className="app-wedo__grid">
          <p className="wedo-paraText">
            &#34;To Provide precise quality, on-time delivery, and competitive
            pricing on all products and services.&#34;
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default WeDo;
